import { Defect, DefectSoort } from '@/types/Defecten';
import { endOfTomorrow2AM } from '@/utils/dateUtils';
import { EenheidStatus } from '@/views/ddp/types/ddpTypes';

export type FilterDefectProps = {
  soorten?: DefectSoort[];
  /** True laat alleen de actieve defecten zien die niet gereedgemeld zijn. */
  active?: boolean;
  eenheidStatus?: { [eenheid: string]: EenheidStatus };
  vanaf?: Date | string;
  tot?: Date | string;
};

/**
 * Filter de gewenste defecten. Laat de default waarden leeg om de desbetreffende filter niet toe te passen.
 *
 * - Filter op defectsoort;
 * - filtert defect op wel/niet (of allebei) gereedgemeld;
 * - filtert defect op eenheid status;
 * - filtert defect op tijd
 *
 * @param props FilterDefectProps
 * @returns A function that can be given the the .filter(filterDefect())
 */
export function filterDefecten({
  active = undefined,
  soorten = [],
  eenheidStatus = undefined,
  vanaf = undefined,
  tot = undefined,
}: FilterDefectProps) {
  const soortFilter = new Set(soorten);
  return (defect: Defect): boolean => {
    const filterSoort = soorten.length ? soortFilter.has(defect.soort) : true;
    const filterGereedgemeld = (active ?? false) === true ? !defect.gereedgemeld : true;
    const filterEenheidStatus =
      eenheidStatus && Object.values(eenheidStatus)?.length
        ? eenheidStatus?.[defect.eenheidNummer]?.toelating === 'OPERATIONEEL'
        : true;
    const vanafDatum = typeof vanaf === 'string' ? new Date(vanaf) : vanaf;
    const totDatum = typeof tot === 'string' ? new Date(tot) : tot;
    const filterBeginGteVanaf =
      (vanafDatum && vanafDatum.getTime() <= new Date(defect.beginTijd as string).getTime()) ?? true;
    const filterBeginSteTot =
      (totDatum && totDatum.getTime() >= new Date(defect.beginTijd as string).getTime()) ?? true;
    const finalBool =
      filterSoort && filterGereedgemeld && filterEenheidStatus && filterBeginGteVanaf && filterBeginSteTot;
    return finalBool;
  };
}
/**
 * Gebruik deze filter bij het initieel filteren van de defecten op de plank.
 *
 * @param defecten
 * @param eenheidStatus
 * @returns
 */
export function filterPlankDefecten(defecten: Defect[], eenheidStatus: { [eenheid: string]: EenheidStatus }): Defect[] {
  return defecten.filter(
    filterDefecten({
      eenheidStatus,
      soorten: ['DEFECT_NIET_INZETBAAR', 'BEPERKING_IN_TREINDIENST', 'GEEN_BEPERKINGEN'],
      active: true,
      tot: endOfTomorrow2AM(new Date(), 2),
    }),
  );
}
